module.exports = __webpack_public_path__ + "img/Cutaways_house_4_a.4ff5a94e.jpg";